export default __webpack_public_path__ + "static/media/WBBL_BBL_Logos.3717aa8e.png";